import * as React from 'react';

type Props = {
  width?: string;
  height?: string;
  filled?: boolean;
};

/**
 * MUI icon for "Thumb up" chat action
 */
const ThumbUpIcon = ({ width = '16', height = '16', filled = false }: Props) =>
  filled ? (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M11 14H4.33331V5.33333L8.99998 0.666667L9.83331 1.5C9.91109 1.57778 9.97498 1.68333 10.025 1.81667C10.075 1.95 10.1 2.07778 10.1 2.2V2.43333L9.36665 5.33333H13C13.3555 5.33333 13.6666 5.46667 13.9333 5.73333C14.2 6 14.3333 6.31111 14.3333 6.66667V8C14.3333 8.07778 14.325 8.16111 14.3083 8.25C14.2916 8.33889 14.2666 8.42222 14.2333 8.5L12.2333 13.2C12.1333 13.4222 11.9666 13.6111 11.7333 13.7667C11.5 13.9222 11.2555 14 11 14ZM2.99998 5.33333V14H0.333313V5.33333H2.99998Z"
        fill="#1E2229"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="currentColor">
      <path
        d="M6.00008 14.6667H12.0001C12.5534 14.6667 13.0267 14.3333 13.2267 13.8533L15.2401 9.15334C15.3001 9.00001 15.3334 8.84001 15.3334 8.66668V7.33334C15.3334 6.60001 14.7334 6.00001 14.0001 6.00001H9.79341L10.4267 2.95334L10.4467 2.74001C10.4467 2.46668 10.3334 2.21334 10.1534 2.03334L9.44675 1.33334L5.05341 5.72668C4.81341 5.96668 4.66675 6.30001 4.66675 6.66668V13.3333C4.66675 14.0667 5.26675 14.6667 6.00008 14.6667ZM6.00008 6.66668L8.89341 3.77334L8.00008 7.33334H14.0001V8.66668L12.0001 13.3333H6.00008V6.66668ZM0.666748 6.66668H3.33341V14.6667H0.666748V6.66668Z"
        fill="#1E2229"
      />
    </svg>
  );

export default ThumbUpIcon;
